import React from "react";
import { ModeRendererProps } from "./types";

export function CalderHoweMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Howe halo and radial blades */}
      <g transform="translate(397 540)">
        <circle r="320" fill="url(#howeHalo)" />
        {Array.from({ length: 24 }).map((_, i) => (
          <use
            key={i}
            href="#blade"
            fill="url(#bladeGrad)"
            opacity={0.55}
            transform={`rotate(${i * 15}) translate(0 ${180}) rotate(${i % 2 ? 20 : -20})`}
          />
        ))}
        {Array.from({ length: 8 }).map((_, i) => (
          <circle key={i} r={60 + i * 26} fill="none" stroke={i % 2 ? brand.aqua : brand.violet} strokeOpacity={0.25} />
        ))}
      </g>

      {/* Calder mobile — rods and discs */}
      <g transform="translate(397 540)">
        <line x1={-180} y1={-300} x2={180} y2={-300} stroke={brand.white} strokeWidth={3} />
        <line x1={-160} y1={-300} x2={-110} y2={-230} stroke={brand.white} strokeWidth={2} />
        <line x1={-20} y1={-300} x2={-10} y2={-220} stroke={brand.white} strokeWidth={2} />
        <line x1={120} y1={-300} x2={170} y2={-210} stroke={brand.white} strokeWidth={2} />
        <line x1={-110} y1={-230} x2={-10} y2={-220} stroke={brand.white} strokeWidth={3} />
        <line x1={-10} y1={-220} x2={90} y2={-240} stroke={brand.white} strokeWidth={3} />
        <line x1={90} y1={-240} x2={170} y2={-210} stroke={brand.white} strokeWidth={3} />
        <circle cx={-190} cy={-200} r={34} fill="#E63946" />
        <circle cx={-10} cy={-190} r={22} fill="#FFD100" />
        <circle cx={105} cy={-260} r={18} fill="#1D4ED8" />
        <circle cx={170} cy={-200} r={28} fill={brand.white} />
        <circle cx={60} cy={-180} r={12} fill={brand.black} />
      </g>
    </g>
  );
}
